<p-dialog
  [modal]="true"
  [(visible)]="visible"
  (onHide)="closeModal()"
  class="mx-10"
>
  @switch (tripCreationModalService.step()) {
    @case ("selectMethod") {
      <app-creation-method-selector />
    }
    @case ("excelImport") {
      <app-excel-import />
    }
    @default {
      <app-trip-basic-info-form />
    }
  }
</p-dialog>
